export default "__VITE_ASSET__3kj3ndHp__"